module.exports = __webpack_public_path__ + "img/red.322526f1.svg";